var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: (_vm.dataFrom.controlsId ? _vm.$t("编辑") : _vm.$t("新增")) + _vm.$t("控件"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("控件名称")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50,
      placeholder: _vm.$t("请输入") + _vm.$t("控件名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mark",
      label: _vm.$t("控件标识")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      placeholder: _vm.$t("请输入") + _vm.$t("控件标识"),
      disabled: _vm.dataFrom.controlsId ? true : false
    },
    model: {
      value: _vm.dataFrom.mark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mark", $$v);
      },
      expression: "dataFrom.mark"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "pageType",
      label: _vm.$t("应用页面类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("应用页面类型"),
      mode: "multiple",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.dataFrom.pageType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "pageType", $$v);
      },
      expression: "dataFrom.pageType"
    }
  }, _vm._l(_vm.PAGETYPE, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.key
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件数据源")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("控件数据源"),
      mode: "multiple",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.dataFrom.controlsSourceId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "controlsSourceId", $$v);
      },
      expression: "dataFrom.controlsSourceId"
    }
  }, _vm._l(_vm.controlsList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: String(item.id)
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100
    },
    model: {
      value: _vm.dataFrom.remarks,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remarks", $$v);
      },
      expression: "dataFrom.remarks"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };